import { useLocation } from "react-router";
import ActoRoutes from "@acto/taskpane/core/router/routes.config";
import { useCustomerById } from "@acto/taskpane/core/data-access/customers/useCustomerById";
import { useDirectionalNavigate } from "@acto/taskpane/field-sales-2/utils/viewTransitions";
import type { NavigationState } from "@acto/taskpane/core/chat";

/**
 * Returns a handler that opens the chat, carrying the current customer as context and the
 * originating path so chat can navigate back. Shared by the customer bottom navs.
 */
export function useOpenCustomerChat(clientId: string | undefined): () => void {
  const navigate = useDirectionalNavigate();
  const location = useLocation();
  const { data: customer } = useCustomerById(clientId ?? "");

  return () => {
    const state: NavigationState = {
      from: location.pathname,
      ...(customer && {
        customerContext: {
          id: customer.id,
          externalReference: customer.externalReference,
          name: customer.name || "-",
        },
      }),
    };

    navigate(ActoRoutes.CHAT, { state });
  };
}
